<template>
  <div class="module_course page_content" aria-label="Report Page" v-if="permission && permission.version === '5'">
    <course-header :course-id="course.uuid" :is-advisor-viewing-report="isAdvisorViewingReport" class="header_course_dashboard"></course-header>
    <div class="row page_content_container">
      <div class="col-11 dasboard-left-section report-Page">
        <div class="col-12">
          <b-row v-if="showManualGradingView">
            <manual-grading :data="manualGradingParameter" @saveScore="afterSaveScore"></manual-grading>
          </b-row>
          <b-row v-else>
            <b-col cols="12" class="report-section">
              <b-row class="heading">
                <div class="col-10" style="position: relative;">
                  <span style="float: left; margin-left: 15px;" class="ace_sec_hd">Reports :: </span>
                  <span>
                    <b-breadcrumb :items="breadcrumbItems"/>
                  </span>
                </div>
                <div class="col-2">
                  <div v-if="loadScoreTimeProgressGear" style="float: right; width: 30px; margin-right: 14px;">
                    <score-time-progress
                      @clicked="showHideScoreTimeProgressColumn"
                      :title="'Show Columns'"
                      :is-course-report="isCourseReport"
                      :style="{visibility: (isShowLearnosityReport) ? 'hidden' : 'visible'}"
                      :is-remove-progess-checkbox="(columns.length > 2 && (columns[1].summary.competencyType === 'MC'))">
                    </score-time-progress>
                  </div>
                  <template v-if="!isAdvisorViewingReport">
                      <b-btn @click="downloadExportLTIAssignmentGrade" style="float: right; margin-right: 22px;" v-if="!showExportButton && isGradeCSVDownloadAllowed" >export lti grade</b-btn>
                    <template v-if="showExportButton">
                      <b-btn @click="exportClassSummary" style="float: right; margin-right: 22px;">export</b-btn>
                    </template>
                    <template v-else>
                      <b-btn v-if="isUpdateCourseStatus" @click="saveUsersStatusInCourse" :disabled="selected.length === 0" style="float: right; margin-right: 10px;">save status</b-btn>
                    </template>
                  </template>
                </div>
              </b-row>
              <div class="report-column">
                <div class="dashboard-row mt-2" v-if="isShowLearnosityReport">
                  <div class="row competency_row w-100">
                    <div class="sort_icon_container" v-if="!isShowAttemptSummary">
                      <span @click="sortDUsers" class="sorting sorting_asc fa fa-caret-up" aria-label="ascending"></span>
                      <span @click="sortAUsers" style="display: none;" class="sorting sorting_desc fa fa-caret-down" aria-label="descending"></span>
                    </div>
                    <template v-if="isShowAttemptSummary">
                      <div class="question-report-container ml-4">
                        <div class="student-col">
                          <b-table bordered :items="attemptSummaries" :fields="questions" :isRowHeader="true" :head-variant="'light'" class="student-name-table">
                            <template slot="name" slot-scope="row">
                              <div class="column first-col" v-b-tooltip.hover :title="row.value">
                                <span class="icon-user"></span>
                                <span class="user-name">{{row.value}} </span>
                              </div>
                            </template>
                          </b-table>
                        </div>
                        <div class="table-responsive question-table">
                          <div class="tbl-hd">
                            <b-table bordered :fields="questions" :isRowHeader="true" :head-variant="'light'" class="question-report-table ques-rprt-tbl-hd"></b-table>
                          </div>
                        </div>
                        <div class="table-responsive question-table">
                          <div class="question-table-inner"  @scroll="scrollQuestionTableUserCol">
                            <b-table bordered :items="attemptSummaries" :fields="questions" :isRowHeader="false" :head-variant="'light'" class="question-report-table">
                              <template slot="total" slot-scope="row">
                                <div v-if="(row.value === 'NA')">
                                  <div class="question-score-box not_attempted" title="Not Attempted">
                                    {{ row.value }}
                                  </div>
                                </div>
                                <div v-else>
                                  <div class="question-score-box" :class="{'gradeA': (row.value >= 90), 'gradeB': (row.value >= 80 && row.value < 90), 'gradeC': (row.value >= 65 && row.value < 80), 'gradeD': (row.value >= 40 && row.value < 65), 'gradeE': (row.value < 40), 'not_started': (row.value == null)}">
                                    {{row.value}} %
                                  </div>
                                </div>
                              </template>
                              <template v-for="(col, index) in questionCols" :slot="col" slot-scope="data">
                                <template v-if="data.item[col]">
                                  <span :key="index">
                                    <div v-if="data.item[col].attempted">
                                      <template v-if="data.item[col].automarkable">
                                        <template v-if="data.item[col].correct">
                                          <div class="question-score-box gradeA" title="Auto Graded">
                                            <span class="icon-checkmark" title="Auto Graded" style="color: #fff;"></span>
                                          </div>
                                        </template>
                                        <template v-else>
                                          <div class="question-score-box gradeE" title="Auto Graded">
                                            <span class="icon-cross" style="color: #fff;"></span>
                                          </div>
                                        </template>
                                      </template>
                                      <template v-else>
                                        <template v-if="data.item[col].score === 'NA'">
                                          <div class="question-score-box not_attempted" title="Not Graded">NG</div>
                                        </template>
                                        <template v-else>
                                          <div class="question-score-box" title="Manually Graded" :class="{'gradeA': (data.item[col].score >= 90), 'gradeB': (data.item[col].score >= 80 && data.item[col].score < 90), 'gradeC': (data.item[col].score >= 65 && data.item[col].score < 80), 'gradeD': (data.item[col].score >= 40 && data.item[col].score < 65), 'gradeE': (data.item[col].score < 40), 'not_started': (data.item[col].score == null)}">
                                            {{data.item[col].score}} %
                                          </div>
                                        </template>
                                      </template>
                                    </div>
                                    <div v-else>
                                      <div class="question-score-box not_attempted" title="Not Attempted">NA</div>
                                    </div>
                                  </span>
                                </template>
                                <template v-else>
                                  <div class="question-score-box not_attempted" title="Not Attempted">NA</div>
                                </template>
                              </template>
                            </b-table>
                          </div>
                        </div>
                      </div>
                    </template>
                    <template v-else>
                      <div class="names_tbl_container" @scroll="scrollAttemptsTable">
                        <b-table bordered fixed :items="attempts" :fields="fields" :isRowHeader="false" :head-variant="'light'" class="assessment_report_table tbl_attempts" @head-clicked="showQuestionLevelReport">
                          <template slot="name" slot-scope="row">
                            <div class="column first-col" v-b-tooltip.hover :title="row.value">
                              <span class="icon-user"></span>
                              <span class="user-name">{{row.value}} </span>
                            </div>
                          </template>
                        </b-table>
                      </div>
                      <div class="attempts_tbl_container" @scroll="scrollAttemptsUserTable">
                        <b-table bordered fixed :items="attempts" :fields="fields" :isRowHeader="true" :head-variant="'light'" class="assessment_report_table tbl_attempts" @head-clicked="showQuestionLevelReport">
                          <template slot="score" slot-scope="row">
                            <div :title="row.item.name" v-b-tooltip.hover>
                              <template v-if="(row.value === 'NA')">
                                <div class="score-box not_attempted" title="Not Attempted">
                                  {{ row.value }}
                                </div>
                              </template>
                              <template v-if="(row.value === 'NG')">
                                <div class="score-box ready_for_grade" title="Not Graded">
                                  {{ row.value }}
                                </div>
                              </template>
                              <template v-else>
                                <div class="score-box" :class="{'gradeA': (row.value >= 90), 'gradeB': (row.value >= 80 && row.value < 90), 'gradeC': (row.value >= 65 && row.value < 80), 'gradeD': (row.value >= 40 && row.value < 65), 'gradeE': (row.value < 40), 'not_started': (row.value == null), 'not_attempted2': (row.value == 'NA')}">
                                  {{row.value}} %
                                </div>
                              </template>
                            </div>
                          </template>
                          <template slot="attempt1" slot-scope="row">
                            <template v-if="row.item.attempt1 && (row.item.attempt1.performance || row.item.attempt1.performance === 0)">
                              <template v-if="(row.item.attempt1.performance === 'NA')">
                                <div class="score-box not_attempted" title="Not Attempted">
                                  {{ row.item.attempt1.performance }}
                                </div>
                              </template>
                              <template v-if="(row.item.attempt1.performance === 'NG')">
                                <div class="score-box ready_for_grade" title="Not Graded">
                                  {{ row.item.attempt1.performance }}
                                </div>
                              </template>
                              <template v-else>
                                <div class="score-box" :id="'at1_r_' + row.item.userId" :class="gradeStatus('at1_r_' + row.item.userId, row.item.attempt1.performance)">
                                  {{row.item.attempt1.performance}} %
                                </div>
                              </template>
                              <template v-if="row.item.attempt1.manualGradingRequired">
                                <b-button
                                  class="ic_btn ic_btn_view"
                                  size="sm"
                                  v-if="row.item.attempt1.manuallyGraded"
                                  @click.stop="openAttemptReport(row.item, row.item.attempt1, $event.target)"
                                  :aria-label="$t('view')"
                                  :title="$t('viewReportTitle')"
                                  v-b-tooltip.hover
                                  :delay="{ show: 200, hide: 100 }"
                                  placement="bottom">
                                    <span class="ic ic24-eye"></span>
                                </b-button>

                                <b-button
                                  class="ic_btn ic_btn_grade"
                                  size="sm"
                                  v-else
                                  @click.stop="openManualGrading(row.item, row.item.attempt1)"
                                  :title="$t('gradeTitle')"
                                  :aria-label="$t('gradeAria')"
                                  :disabled="permission.systemPermission.readOnly"
                                  :id="row.item.attempt1.assessmentId + '_report'">
                                    <span class="ic ic24-report"></span>
                                </b-button>
                                <b-tooltip
                                  :target="row.item.attempt1.assessmentId + '_report'"
                                  triggers="hover focus"
                                  placement="bottom"
                                  :delay="{ show: 200, hide: 100 }"
                                  boundary="window">
                                   {{ $t('gradeTitle') }}
                                </b-tooltip>
                              </template>
                              <template v-else>
                                <b-button
                                  class="ic_btn ic_btn_view"
                                  @click.stop="openAttemptReport(row.item, row.item.attempt1, $event.target)"
                                  :aria-label="$t('viewAria')"
                                  :id="row.item.attempt1.assessmentId + '_view'">
                                  <span class="ic ic24-eye"></span>
                                </b-button>
                                <b-tooltip
                                  :target="row.item.attempt1.assessmentId + '_view'"
                                  triggers="hover focus"
                                  placement="bottom"
                                  :delay="{ show: 200, hide: 100 }"
                                  boundary="window">
                                   {{ $t('viewReportTitle') }}
                                </b-tooltip>
                              </template>

                              <b-button
                                class="ic_btn ic_btn_del"
                                @click.stop="showAttemptDeleteConfirmBox(row.item, row.item.attempt1, $event.target)"
                                :aria-label="$t('deleteAttemptAria')"
                                :id="row.item.attempt1.assessmentId + '_del'">
                                  <span class="ic ic24-bin2"></span>
                              </b-button>
                              <b-tooltip
                                :target="row.item.attempt1.assessmentId + '_del'"
                                triggers="hover focus"
                                placement="bottom"
                                :delay="{ show: 200, hide: 100 }"
                                boundary="window">
                                 {{ $t('deleteAttemptTitle') }}
                              </b-tooltip>
                              <b-button
                                class="ic_btn ic_btn_del"
                                @click.stop="showAttemptScoreConfirmBox(row.item, row.item.attempt1, $event.target)"
                                :aria-label="$t('updateAttemptAria')"
                                :id="row.item.attempt1.assessmentId + '_edit'">
                                  <span class="ic ic24-pencil"></span>
                              </b-button>
                              <b-tooltip
                                :target="row.item.attempt1.assessmentId + '_edit'"
                                triggers="hover focus"
                                placement="bottom"
                                :delay="{ show: 200, hide: 100 }"
                                boundary="window">
                                 {{ $t('updateAttemptTitle') }}
                              </b-tooltip>
                              <b-button
                                class="ic_btn ic_btn_del"
                                v-if="row.item.diagnosticTest"
                                @click.stop="showDiagnosticTestReport(row.item.attempt1.assessmentId, row.item.userId)"
                                :aria-label="$t('competencyBreakdownReportAria')"
                                :id="row.item.attempt1.assessmentId + '_cbr'">
                                  <span class="ic ic24-reports2"></span>
                              </b-button>
                              <b-tooltip
                                :target="row.item.attempt1.assessmentId + '_cbr'"
                                triggers="hover focus"
                                placement="bottom"
                                :delay="{ show: 200, hide: 100 }"
                                boundary="window">
                                 {{ $t('competencyBreakdownReportTitle') }}
                              </b-tooltip>

                            </template>
                          </template>
                          <template slot="attempt2" slot-scope="row">
                            <template v-if="row.item.attempt2 && (row.item.attempt2.performance || row.item.attempt2.performance === 0)">
                              <template v-if="(row.item.attempt2.performance === 'NA')">
                                <div class="score-box not_attempted" title="Not Attempted">
                                  {{ row.item.attempt2.performance }}
                                </div>
                              </template>
                              <template v-if="(row.item.attempt2.performance === 'NG')" title="Not Graded">
                                <div class="score-box ready_for_grade">
                                  {{ row.item.attempt2.performance }}
                                </div>
                              </template>
                              <template v-else>
                                <div class="score-box" :class="{'gradeA': (row.item.attempt2.performance >= 90), 'gradeB': (row.item.attempt2.performance >= 80 && row.item.attempt2.performance < 90), 'gradeC': (row.item.attempt2.performance >= 65 && row.item.attempt2.performance < 80), 'gradeD': (row.item.attempt2.performance >= 40 && row.item.attempt2.performance < 65), 'gradeE': (row.item.attempt2.performance < 40), 'not_started': (row.item.attempt2.performance == null)}">
                                  {{row.item.attempt2.performance}} %
                                </div>
                              </template>
                              <template v-if="row.item.attempt2.manualGradingRequired">
                                <b-button class="ic_btn ic_btn_view" size="sm" v-if="row.item.attempt2.manuallyGraded" @click.stop="openAttemptReport(row.item, row.item.attempt2, $event.target)" v-b-tooltip.hover title="view report" aria-label="view">
                                  <span class="ic ic24-eye"></span>
                                </b-button>
                                <b-button class="ic_btn ic_btn_grade" size="sm" v-else @click.stop="openManualGrading(row.item, row.item.attempt2)" v-b-tooltip.hover title="grade" aria-label="grade" :disabled="permission.systemPermission.readOnly">
                                  <span class="ic ic24-report"></span>
                                </b-button>
                              </template>
                              <template v-else>
                                <b-button  @click.stop="openAttemptReport(row.item, row.item.attempt2, $event.target)" class="btn_2" aria-label="view">view</b-button>
                              </template>
                            </template>
                          </template>
                          <template slot="attempt3" slot-scope="row">
                            <template v-if="row.item.attempt3 && (row.item.attempt3.performance || row.item.attempt3.performance === 0)">
                              <template v-if="(row.item.attempt3.performance === 'NA')">
                                <div class="score-box not_attempted" title="Not Attempted">
                                  {{ row.item.attempt3.performance }}
                                </div>
                              </template>
                              <template v-if="(row.item.attempt3.performance === 'NG')">
                                <div class="score-box ready_for_grade" title="Not Graded">
                                  {{ row.item.attempt3.performance }}
                                </div>
                              </template>
                              <template v-else>
                                <div class="score-box" :class="{'gradeA': (row.item.attempt3.performance >= 90), 'gradeB': (row.item.attempt3.performance >= 80 && row.item.attempt3.performance < 90), 'gradeC': (row.item.attempt3.performance >= 65 && row.item.attempt3.performance < 80), 'gradeD': (row.item.attempt3.performance >= 40 && row.item.attempt3.performance < 65), 'gradeE': (row.item.attempt3.performance < 40), 'not_started': (row.item.attempt3.performance == null)}">
                                  {{row.item.attempt3.performance.toFixed(2)}} %
                                </div>
                              </template>
                              <template v-if="row.item.attempt3.manualGradingRequired">
                                <b-button class="ic_btn ic_btn_view" size="sm" v-if="row.item.attempt3.manuallyGraded" @click.stop="openAttemptReport(row.item, row.item.attempt3, $event.target)" v-b-tooltip.hover title="view report" aria-label="view">
                                  <span class="ic ic24-eye"></span>
                                </b-button>
                                <b-button class="ic_btn ic_btn_grade" size="sm" v-else @click.stop="openManualGrading(row.item, row.item.attempt3)" v-b-tooltip.hover title="grade" aria-label="grade" :disabled="permission.systemPermission.readOnly">
                                  <span class="ic ic24-report"></span>
                                </b-button>
                              </template>
                              <template v-else>
                                <b-button  @click.stop="openAttemptReport(row.item, row.item.attempt3, $event.target)" class="btn_2" aria-label="view">view</b-button>
                              </template>
                            </template>
                          </template>
                        </b-table>
                      </div>
                    </template>
                  </div>

                  <b-modal id="attemptReportInfo" size="lg" centered :title="knowledgeCheckReportTitle" @hidden="showAttemptReport = false" hide-footer>
                    <template v-if="showAttemptReport">
                      <div slot="modal-header" class="header-section">
                        <div class="popup-heading">{{knowledgeCheckReportTitle}}</div>
                        <div class="float-right">
                          <template v-if="reGradeItem.attempt.manualGradingRequired">
                            <b-button size="sm" @click.stop="openManualGrading(reGradeItem, reGradeItem.attempt)" class="mr-1" aria-label="re-grade" :disabled="permission.systemPermission.readOnly">re-grade</b-button>
                          </template>
                          <button type="button" aria-label="Close" class="attempt-report-close" @click="closeAttemptReport">x</button>
                        </div>
                      </div>
                      <div class="popup_inner_content">
                        <class-activity-outcome :activity-outcome-parameter="activityOutcomeParameter"></class-activity-outcome>
                      </div>
                    </template>
                  </b-modal>
        <b-modal id="diagnosticReportModal" ref="diagnosticTestReportInfo" size="lg" centered  @hidden="isShowDiagnosticTestReport = false" hide-footer class="learnosity-report-modal">
            <div slot="modal-header" class="header-section">
              {{diagnosticTestReport.userName}} - Diagnostic Test Results - Attempt on {{diagnosticTestReport.testDate}}
              <div class="float-right">
                <button type="button" aria-label="Close" class="attempt-report-close" @click="closeDiagnosticTestReport">x</button>
              </div>
            </div>
            <div class="popup_inner_content">
              <div class="course_name">
                {{diagnosticTestReport.course}} <img width=300 height=40 :src="institution.logo" align=right v-if="institution.logo" ></img>
              </div>
              <table class="table report_table">
                <thead>
                  <tr>
                    <th>Topic</th>
                    <th>Score</th>
                    <th>Performance</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="module in diagnosticTestReport.modules">
                    <td>{{module.competencyName}}</td>
                    <td>
                      <template v-if="module.performance >= 90">
                        <div class="sec_txt_score gradeA">
                          <span class="txt">{{module.correct}}/{{module.max}}</span>
                          <span class="ic ic24-flower1"></span>
                        </div>
                      </template>
                      <template v-if="module.performance >= 80 && module.performance < 90">
                        <div class="sec_txt_score gradeB">
                          <span class="txt">{{module.correct}}/{{module.max}}</span>
                          <span class="ic ic24-flower1"></span>
                        </div>
                      </template>
                      <template v-if="module.performance >= 65 && module.performance < 80">
                        <div class="sec_txt_score gradeC">
                          <span class="txt">{{module.correct}}/{{module.max}}</span>
                          <span class="ic ic24-flower1"></span>
                        </div>
                      </template>
                      <template v-if="module.performance >= 40 && module.performance < 65">
                        <div class="sec_txt_score gradeD">
                          <span class="txt">{{module.correct}}/{{module.max}}</span>
                          <span class="ic ic24-flower1"></span>
                        </div>
                      </template>
                      <template v-if="module.performance < 40">
                        <div class="sec_txt_score gradeE">
                          <span class="txt">{{module.correct}}/{{module.max}}</span>
                          <span class="ic ic24-flower1"></span>
                        </div>
                      </template>
                    </td>
                    <td>
                      <template v-if="module.performance >= 90">
                        <div class="performance_bx gradeA">{{module.performance}}%</div>
                      </template>
                      <template v-if="module.performance >= 80 && module.performance < 90">
                        <div class="performance_bx gradeB">{{module.performance}}%</div>
                      </template>
                      <template v-if="module.performance >= 65 && module.performance < 80">
                        <div class="performance_bx gradeC">{{module.performance}}%</div>
                      </template>
                      <template v-if="module.performance >= 40 && module.performance < 65">
                        <div class="performance_bx gradeD">{{module.performance}}%</div>
                      </template>
                      <template v-if="module.performance < 40">
                        <div class="performance_bx gradeE">{{module.performance}}%</div>
                      </template>
                    </td>
                    <td>{{module.status}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          <template v-if="!isShowDiagnosticTestReport">
            <stretch></stretch>
          </template>
        </b-modal>

                  <b-modal id="attemptDeleteConfirm" size="md" class="modal__v22_2" centered title="" @hidden="showAttemptDeleteBox = false">
                    <template v-if="showAttemptDeleteBox">

                      <div slot="modal-header" class="header-section">
                        <div class="hd_txt">Please Confirm!</div>
                        <div class="close_btn_container">
                          <button class="btn_close" aria-label="close" @click="closeAttemptDeleteConfirmBox">
                            <span class="ic-close"></span>
                          </button>
                        </div>
                      </div>

                      <div class="popup_inner_content">
                        <!--Are you sure, this can not be undo?-->
                        <p>Deleting the attempt will allow the learner to retake the knowledge check.</p>
                        <p>If it is a diagnostic test, the progress and performance of the first attempt will be preserved.</p>
                        <p>To confirm the deletion of this assessment attempt, click "ok"?</p>
                      </div>

                      <div slot="modal-footer">
                        <div class="btn_container">
                          <b-button class="btn" @click="closeAttemptDeleteConfirmBox" aria-label="cencel">
                            cancel
                          </b-button>
                          <b-button class="btn" @click.stop="deleteAttemptConfirm(deleteAttemptRowItem, deleteAttemptSession)" aria-label="delete">
                            ok
                          </b-button>
                        </div>
                      </div>
                    </template>
                  </b-modal>

                  <b-modal id="attemptScoreConfirm" size="md" class="modal__v22_2" centered title="" @hidden="showAttemptScoreBox = false">
                    <template v-if="showAttemptScoreBox">

                      <div slot="modal-header" class="header-section">
                        <div class="hd_txt">Please Confirm!</div>
                        <div class="close_btn_container">
                          <button class="btn_close" aria-label="close" @click="closeAttemptScoreConfirmBox">
                            <span class="ic-close"></span>
                          </button>
                        </div>
                      </div>

                      <div class="popup_inner_content">
                        <p>Update the attempt score will allow you to override the score.</p>
                        <p>Current score {{deleteAttemptSession.points}} out of {{deleteAttemptSession.totalPoints}}</p>
                        <p>New score <input type="text" v-model="newScore" style="width: 10%;"/> out of {{deleteAttemptSession.totalPoints}}</p>
                      </div>

                      <div slot="modal-footer">
                        <div class="btn_container">
                          <b-button class="btn" @click="closeAttemptScoreConfirmBox" aria-label="cencel">
                            cancel
                          </b-button>
                          <b-button class="btn" @click.stop="scoreAttemptConfirm(deleteAttemptRowItem, deleteAttemptSession)" aria-label="update">
                            update
                          </b-button>
                        </div>
                      </div>
                    </template>
                  </b-modal>

                </div>
                <b-row class="competency-details-row mt-2" v-else-if="columns.length > 1 && items.length > 1">
                  <div class="user-column">
                    <div class="columns" v-for="(column, index) in columns">
                      <div class="column text-center col_row col_1" :class="{'non_kc_col': ((column.summary.competencyType !== 'ASSESSMENT') && (column.summary.competencyType !== 'RESOURCE'))}">
                        <template v-if="index === 0">
                          <div class="first-col">
                            <span>{{ column.title }}</span>
                            <span class="sort_icon_container">
                            <span @click="sortDUsers" class="sorting sorting_asc fa fa-caret-up"></span>
                            <span @click="sortAUsers" style="display: none;" class="sorting sorting_desc fa fa-caret-down"></span>
                            </span>
                          </div>
                        </template>
                      </div>
                    </div>
                    <div class="table_first_col">
                      <div class="class_report_row" v-for="(item, index) in items">
                        <div class="columns first">
                          <div class="column first-col">
                            <template v-if="index === 0">
                              <span class="user-name text-center" v-b-tooltip.hover :title="item.name">{{ item.name }}</span>
                            </template>
                            <template v-else>
                              <span class="icon-user" v-b-tooltip.hover :title="item.name"></span>
                              <span class="user-name" v-b-tooltip.hover :title="item.name">{{ item.name }}</span>
                              <template v-if="!isAdvisorViewingReport">
                                <template v-if="item.isStudentDropped">
                                  <b-btn class="ic_btn eye" @click="addOrDropStudentFromClassAverage(course.uuid, item.userId, 'addDropped')"  v-b-tooltip.hover title="This student is excluded in class average calculation, click to include in the class average calculation.">
                                    <i class="fas fa-eye-slash"></i>
                                  </b-btn>
                                </template>
                                <template v-else>
                                  <b-btn class="ic_btn eye" @click="addOrDropStudentFromClassAverage(course.uuid, item.userId, 'drop')"  v-b-tooltip.hover title="This student is included in class average calculation, click to exclude from the class average calculation.">
                                    <i class="fas fa-eye"></i>
                                  </b-btn>
                                </template>
                              </template>
                            </template>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- status update section -->
                  <div class="user-column" v-if="isUpdateCourseStatus" style="width: 180px;">
                    <div class="columns" v-for="(column, index) in columns" style="border-left: none;">
                      <div class="column text-center col_row col_1"></div>
                    </div>
                    <div class="table_first_col">
                      <div class="class_report_row" v-for="(item, index) in items">
                        <div class="columns first" style="border-left: none;">
                          <div class="column first-col">
                            <template v-if="index > 0">
                              <span>
                                <div class="float-left">
                                  <select v-model="item.status" style="width: 110px; padding: 0; height: 28px;">
                                    <option value="0">Scheduled</option>
                                    <option value="1">In Progress</option>
                                    <option value="2">Completed</option>
                                  </select>
                                </div>
                                <div class="float-left ml-3 mt-1">
                                  <!--
                                  <b-button variant="primary" :disabled="isStatusDisabled(item)" @click="saveUserStatusInCourse(item)">Save</b-button>
                                  -->
                                  <label class="form-checkbox">
                                    <input type="checkbox" :value="item" v-model="selected" style="width: 22px; height: 22px;" />
                                  </label>
                                </div>
                              </span>
                            </template>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- #end status update section -->
                  <div class="table-content-section">
                    <div class="table_row_header" @scroll="scrollTableHorizontal">
                      <div class="competency_row">
                        <div class="columns" v-for="(column, index) in columns">
                          <div class="column text-center col_row col_1" :class="{'non_kc_col': ((column.summary.competencyType !== 'ASSESSMENT') && (column.summary.competencyType !== 'RESOURCE'))}">
                            <template  v-if="index !== 0">
                              <template v-if="column !== undefined && column.isClickable">
                                <template v-if="column.summary.competencyType === 'ASSESSMENT'">
                                  <router-link :to="{ name: 'classReport', params: { uuid: course.uuid, competencyId: column.summary.entityId, isShowLearnosityReport: true, isShowAttemptSummary: false, title: column.title, users: users, isAdvisorViewingReport: isAdvisorViewingReport } }">
                                    <div class="w-100 column-title">{{ column.title }}</div>
                                    <div class="head">
                                      <span class="score-column">Score</span>
                                      <span class="time-column">KC Time</span>
                                      <!--<span class="progress-column" v-if="column.summary.competencyType !== 'ASSESSMENT'">Progress</span>-->
                                      <span class="resource-time-column">Resource Time</span>
                                      <!--<span class="last-activity-column" v-if="isCourseReport">Last Activity</span>-->
                                    </div>
                                  </router-link>
                                </template>
                                <template v-else-if="column.summary.competencyType === 'RESOURCE'">
                                  <div class="w-100 column-title">{{ column.title }}</div>
                                  <div class="head">
                                    <span class="score-column">Score</span>
                                    <span class="time-column">KC Time</span>
                                    <!--<span class="progress-column" v-if="column.summary.competencyType !== 'ASSESSMENT'">Progress</span>-->
                                    <span class="resource-time-column">Resource Time</span>
                                    <!--<span class="last-activity-column" v-if="isCourseReport">Last Activity</span>-->
                                  </div>
                                </template>
                                <template v-else>
                                  <router-link :to="{ name: 'classReport', params: { uuid: course.uuid, competencyId: column.summary.competencyId, isShowLearnosityReport: false, isShowAttemptSummary: false, title: column.title, isAdvisorViewingReport: isAdvisorViewingReport } }">
                                    <div class="w-100 column-title">{{ column.title }}</div>
                                    <div class="head">
                                      <span class="score-column">Score</span>
                                      <span class="time-column">KC Time</span>
                                      <span class="resource-time-column">Resource Time</span>
                                      <span class="progress-column">Progress</span>
                                      <span class="last-activity-column" v-if="isCourseReport">Last Activity</span>
                                    </div>
                                  </router-link>
                                </template>
                              </template>
                              <template v-else>
                                <div class="column-title">{{ column.title }}</div>
                                <div class="head">
                                  <span class="score-column">Score</span>
                                  <span class="time-column">KC Time</span>
                                  <span class="resource-time-column">Resource Time</span>
                                  <span class="progress-column" v-if="((column.summary.competencyType !== 'ASSESSMENT') && (column.summary.competencyType !== 'RESOURCE'))">Progress</span>
                                  <span class="last-activity-column" v-if="isCourseReport">Last Activity</span>
                                </div>
                              </template>
                            </template>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="table_row_container" @scroll="scrollTable">
                      <div class="class_report_row" v-for="(item, index) in items">
                        <div class="w-100 column_row">
                          <div class="columns" v-for="col in item.cols">
                            <div v-if="col !== undefined" :title="col.summary.firstName">
                              <template v-if="col !== undefined && col.isClickable">
                                <template v-if="col !== undefined && col.summary.competencyType === 'ASSESSMENT'">
                                  <!--<router-link :to="{ name: 'classReport', params: { uuid: course.uuid, competencyId: col.summary.entityId, isShowLearnosityReport: true, isShowAttemptSummary: false, title: col.summary.titleForStudent, users: users } }">-->
                                  <div class="col_row col_1">
                                    <div class="column score-column" style="position: relative;">
                                      <span v-if="col.score == 'N/A'">
                                      <span v-if="col.summary.status == -1 && item.name !== 'Class Average'">
                                      <span class="score-box noGrade" @click="unlockQuest(col.summary.userId, col.summary.courseId, col.summary.entityId)">
                                      Unlock
                                      </span>
                                      </span>
                                      <span v-else>
                                      <span v-if="col.summary.status == 0 && item.name !== 'Class Average'">
                                      <span class="score-box noGrade">
                                      Available
                                      </span>
                                      </span>
                                      <span v-else>
                                      <span class="score-box noGrade">
                                      {{ col.score }}
                                      </span>
                                      </span>
                                      </span>
                                      </span>
                                      <span v-else>
                                      <span class="score-box" :class="{'gradeA': (col.score >= 90), 'gradeB': (col.score >= 80 && col.score < 90), 'gradeC': (col.score >= 65 && col.score < 80), 'gradeD': (col.score >= 40 && col.score < 65), 'gradeE': (col.score < 40), 'not_started': (col.score == null)}">
                                      {{ col.score }}%
                                      </span>
                                      </span>
                                    </div>
                                    <div class="column time-column"><span class="time-value-box">{{ col.time }}</span></div>
                                    <!--
                                      <div class="column progress-column" v-if="((index > 0) && (col.summary.competencyType !== 'ASSESSMENT'))">
                                        <competency-summary-progress-bar :summary="col.summary" :class="''"></competency-summary-progress-bar>
                                      </div>
                                      -->
                                    <div class="column resource-time-column"><span class="time-value-box">N/A</span></div>
                                    <!--<div class="column last-activity-column" v-if="(index > 0) && isCourseReport"><span class="last-activity-value-box">{{ getFormattedDateTime(col.summary.lastActivityTime) }}</span></div>-->
                                  </div>
                                  <!--                                    </router-link> -->
                                </template>
                                <template v-else-if="col !== undefined && col.summary.competencyType === 'RESOURCE'">
                                  <div class="col_row col_1">
                                    <div class="column score-column" style="position: relative;">
                                      <span v-if="col.score == 'N/A'">
                                      <span class="score-box noGrade">
                                      {{ col.score }}
                                      </span>
                                      </span>
                                      <span v-else>
                                      <span class="score-box" :class="{'gradeA': (col.score >= 90), 'gradeB': (col.score >= 80 && col.score < 90), 'gradeC': (col.score >= 65 && col.score < 80), 'gradeD': (col.score >= 40 && col.score < 65), 'gradeE': (col.score < 40), 'not_started': (col.score == null)}">
                                      {{ col.score }}%
                                      </span>
                                      </span>
                                    </div>
                                    <div class="column time-column"><span class="time-value-box">N/A</span></div>
                                    <!--
                                      <div class="column progress-column" v-if="((index > 0) && (col.summary.competencyType !== 'ASSESSMENT'))">
                                        <competency-summary-progress-bar :summary="col.summary" :class="''"></competency-summary-progress-bar>
                                      </div>
                                      -->
                                    <div class="column resource-time-column"><span class="time-value-box">{{ col.resourceTime }}</span></div>
                                    <!--<div class="column last-activity-column" v-if="(index > 0) && isCourseReport"><span class="last-activity-value-box">{{ getFormattedDateTime(col.summary.lastActivityTime) }}</span></div>-->
                                  </div>
                                </template>
                                <template v-else>
                                  <router-link :to="{ name: 'classReport', params: { uuid: course.uuid, competencyId: col.summary.competencyId, isShowLearnosityReport: false, isShowAttemptSummary: false, title: col.summary.titleForStudent, isAdvisorViewingReport: isAdvisorViewingReport } }">
                                    <div class="col_row col_1" :class="{'non_kc_col': ((col.summary.competencyType !== 'ASSESSMENT') && (col.summary.competencyType !== 'RESOURCE'))}">
                                      <div class="column score-column" style="position: relative;">
                                        <span v-if="col.score == 'N/A'">
                                        <span class="score-box noGrade">
                                        {{ col.score }}
                                        </span>
                                        </span>
                                        <span v-else>
                                        <span class="score-box" :class="{'gradeA': (col.score >= 90), 'gradeB': (col.score >= 80 && col.score < 90), 'gradeC': (col.score >= 65 && col.score < 80), 'gradeD': (col.score >= 40 && col.score < 65), 'gradeE': (col.score < 40), 'not_started': (col.score == null)}">
                                        {{ col.score }}%
                                        <span v-if="col.summary.updatedByDiagnosticTest" title="Updated By Diagnostic Test">
                                        *
                                        </span>
                                        </span>
                                        </span>
                                      </div>
                                      <div class="column time-column"><span class="time-value-box">{{ col.time }}</span></div>
                                      <div class="column resource-time-column"><span class="time-value-box">{{ col.resourceTime }}</span></div>
                                      <div class="column progress-column">
                                        <template v-if="(index > 0)">
                                          <competency-summary-progress-bar :summary="col.summary" :class="''"></competency-summary-progress-bar>
                                        </template>
                                      </div>
                                      <div class="column last-activity-column" v-if="(index > 0) && isCourseReport"><span class="last-activity-value-box">{{ getFormattedDateTime(col.summary.lastActivityTime) }}</span></div>
                                    </div>
                                  </router-link>
                                </template>
                              </template>
                              <template v-else>
                                <div class="col_row col_1" :class="{'non_kc_col': ((col.summary.competencyType !== 'ASSESSMENT') && (col.summary.competencyType !== 'RESOURCE'))}">
                                  <div class="column score-column" style="position: relative;">
                                    <span v-if="col.score == 'N/A'">
                                    <span class="score-box noGrade">
                                    {{ col.score }}
                                    </span>
                                    </span>
                                    <span v-else>
                                      <span class="score-box" :class="{'gradeA': (col.score >= 90), 'gradeB': (col.score >= 80 && col.score < 90), 'gradeC': (col.score >= 65 && col.score < 80), 'gradeD': (col.score >= 40 && col.score < 65), 'gradeE': (col.score < 40), 'not_started': (col.score == null)}">
                                        {{ col.score }}%
                                        <span
                                          v-if="col.summary.overriddenTime"
                                          @click="openOverrideDetailModal(col.summary)"
                                          class="score_modify_indicator"
                                          :title="$t('overridenByAdvisorTitle')"
                                          v-b-tooltip.hover>
                                        </span>
                                      </span>
                                    </span>
                                  </div>
                                  <div class="column time-column"><span class="time-value-box">{{ col.time }}</span></div>
                                  <div class="column resource-time-column"><span class="time-value-box">{{ col.resourceTime }}</span></div>
                                  <div class="column progress-column">
                                    <template v-if="((index > 0) && ((col.summary.competencyType !== 'ASSESSMENT') && (col.summary.competencyType !== 'RESOURCE')))">
                                      <competency-summary-progress-bar :summary="col.summary" :class="''"></competency-summary-progress-bar>
                                    </template>
                                  </div>
                                  <div class="column last-activity-column" v-if="(index > 0) && isCourseReport"><span class="last-activity-value-box">{{ getFormattedDateTime(col.summary.lastActivityTime) }}</span></div>
                                </div>
                              </template>
                            </div>
                          </div>
                          <template v-if="item.cols.length < (columns.length - 1)">
                            <div class="columns" v-for="i in (columns.length - item.cols.length - 1)">
                              <template v-if="columns[item.cols.length+i].isClickable">
                                <template v-if="columns[item.cols.length+i].summary.competencyType === 'ASSESSMENT'">
                                  <router-link :to="{ name: 'classReport', params: { uuid: course.uuid, competencyId: columns[item.cols.length+i].summary.entityId, isShowLearnosityReport: true, isShowAttemptSummary: false, title: columns[item.cols.length+i].title, users: users, isAdvisorViewingReport: isAdvisorViewingReport } }">
                                    <div class="col_row col_1">
                                      <div class="column score-column" style="position: relative;">
                                        <span class="score-box noGrade">N/A</span>
                                      </div>
                                      <div class="column time-column"><span class="time-value-box">00:00:00</span></div>
                                      <!--
                                        <div class="column progress-column" v-if="(index > 0)">
                                          <competency-summary-progress-bar :summary="{childrenCount: 0, status: 0}" :class="''"></competency-summary-progress-bar>
                                        </div>
                                        -->
                                      <div class="column resource-time-column"><span class="time-value-box">N/A</span></div>
                                      <!--<div class="column last-activity-column" v-if="(index > 0) && isCourseReport"><span class="last-activity-value-box">N/A</span></div>-->
                                    </div>
                                  </router-link>
                                </template>
                                <template v-else-if="columns[item.cols.length+i].summary.competencyType === 'RESOURCE'">
                                  <div class="col_row col_1">
                                    <div class="column score-column" style="position: relative;">
                                      <span class="score-box noGrade">N/A</span>
                                    </div>
                                    <div class="column time-column"><span class="time-value-box">N/A</span></div>
                                    <!--
                                      <div class="column progress-column" v-if="(index > 0)">
                                        <competency-summary-progress-bar :summary="{childrenCount: 0, status: 0}" :class="''"></competency-summary-progress-bar>
                                      </div>
                                      -->
                                    <div class="column resource-time-column"><span class="time-value-box">00:00:00</span></div>
                                    <!--<div class="column last-activity-column" v-if="(index > 0) && isCourseReport"><span class="last-activity-value-box">N/A</span></div>-->
                                  </div>
                                </template>
                                <template v-else>
                                  <router-link :to="{ name: 'classReport', params: { uuid: course.uuid, competencyId: columns[item.cols.length+i].summary.competencyId, isShowLearnosityReport: false, isShowAttemptSummary: false, title: columns[item.cols.length+i].title, isAdvisorViewingReport: isAdvisorViewingReport } }">
                                    <div class="col_row col_1" :class="{'non_kc_col': ((columns[item.cols.length+i].summary.competencyType !== 'ASSESSMENT') && (columns[item.cols.length+i].summary.competencyType !== 'RESOURCE'))}">
                                      <div class="column score-column">
                                        <span class="score-box noGrade">N/A</span>
                                      </div>
                                      <div class="column time-column">
                                        <span class="time-value-box">00:00:00</span>
                                      </div>
                                      <div class="column resource-time-column">
                                        <span class="time-value-box">00:00:00</span>
                                      </div>
                                      <div class="column progress-column">
                                        <template v-if="((index > 0) && ((columns[item.cols.length+i].summary.competencyType !== 'ASSESSMENT') && (columns[item.cols.length+i].summary.competencyType !== 'RESOURCE')))">
                                          <competency-summary-progress-bar :summary="{childrenCount: 0, status: 0}" :class="''"></competency-summary-progress-bar>
                                        </template>
                                      </div>
                                      <div class="column last-activity-column" v-if="(index > 0) && isCourseReport">
                                        <span class="last-activity-value-box">N/A</span>
                                      </div>
                                    </div>
                                  </router-link>
                                </template>
                              </template>
                              <template v-else>
                                <div class="col_row col_1" :class="{'non_kc_col': ((columns[item.cols.length+i].summary.competencyType !== 'ASSESSMENT') && (columns[item.cols.length+i].summary.competencyType !== 'RESOURCE'))}"  :title="col.summary.firstName">
                                  <div class="column score-column" style="position: relative;">
                                    <span class="score-box noGrade">N/A</span>
                                  </div>
                                  <div class="column time-column">
                                    <span class="time-value-box">
                                      <template v-if="columns[item.cols.length+i].summary.competencyType === 'ASSESSMENT'">00:00:00</template>
                                      <template v-else>N/A</template>
                                    </span>
                                  </div>
                                  <div class="column resource-time-column">
                                    <span class="time-value-box">
                                      <template v-if="columns[item.cols.length+i].summary.competencyType === 'RESOURCE'">00:00:00</template>
                                      <template v-else>N/A</template>
                                    </span>
                                  </div>
                                  <div class="column progress-column">
                                    <template v-if="((index > 0) && ((columns[item.cols.length+i].summary.competencyType !== 'ASSESSMENT') && (columns[item.cols.length+i].summary.competencyType !== 'RESOURCE')))">
                                      <competency-summary-progress-bar :summary="{childrenCount: 0, status: 0}" :class="''"></competency-summary-progress-bar>
                                    </template>
                                  </div>
                                  <div class="column last-activity-column" v-if="(index > 0) && isCourseReport"><span class="last-activity-value-box">N/A</span></div>
                                </div>
                              </template>
                            </div>
                          </template>
                        </div>
                      </div>
                      <!-- class_report_row -->
                    </div>
                    <!-- table_row_container -->
                  </div>
                  <!-- table-content-section -->
                </b-row>
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
    <div class="loading-spinner">
      <b-modal style="padding: 0px;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
        <div class="text-center" style="color: #FFF">
          <div><i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i></div>
          <div class="mt-4" v-if="isRecalutingClassAverage">
            <span>Recalculating Class Average</span>
          </div>
        </div>
      </b-modal>
    </div>
<!-- Override Modal -->
        <div class="modal_popup_container course_unlock_modal">
          <b-modal ref="learnerCourseOverrideModal" class="description_modal" size="md" id="course-report-popup" hide-footer>
            <div slot="modal-header" class="header-section">
              <div class="head_txt" style="margin-top: 1px;">Edited Overall Score and Progress</div>
              <div class="btn_container">
                <button type="button" class="btn_close" @click="closeLearnerCourseOverrideModal" data-dismiss="modal" aria-label="Close">
                  <span class="ic-close"></span>
                </button>
              </div>
            </div>

            <div class="row txt_row">
              <div class="col-6">
                Course :
              </div>
              <div class="col-6 fld_val">
                <div v-html="course.title"></div>
              </div>
            </div>
              <div class="row txt_row mt-3">
                <div class="col-6 ">
                  Actual Overall Score :
                </div>
                <div class="col-6 fld_input" v-if="overrideSummary">
                  <span v-if="overrideSummary.overriddenTime" class="exp_info">{{overrideSummary.prePerformance?overrideSummary.prePerformance:0}}%</span>
                  <span v-else class="exp_info">{{overrideSummary.performance}}%</span>
                </div>
              </div>
              <div class="row txt_row mt-3">
                <div class="col-6 ">
                  Edited Overall Score :
                </div>
                <div class="col-6 fld_input" v-if="overrideSummary">
                  <span class="exp_info">{{overrideSummary.performance}}%</span>
                </div>
              </div>

              <div class="row txt_row mt-3">
                <div class="col-6 ">
                  Actual Overall Progress :
                </div>
                <div class="col-6 fld_input" v-if="overrideSummary">
                <div class="progress-bar-label">
                  {{overrideSummary.preChildrenCompleteCount}} of {{overrideSummary.childrenCount}}
                </div>
                <b-progress :max="overrideSummary.childrenCount">
                  <b-progress-bar :value="overrideSummary.preChildrenCompleteCount" class="prog_bar__completed"></b-progress-bar>
                </b-progress>
                </div>
              </div>
              <div class="row txt_row mt-3" v-if="overrideSummary && overrideSummary.overriddenTime>0">
                <div class="col-6 ">
                  Edited Overall Progress :
                </div>
                <div class="col-6 fld_input" >
                <div class="progress-bar-label">
                  {{overrideSummary.childrenCompleteCount}} of {{overrideSummary.childrenCount}}
                </div>
                <b-progress :max="overrideSummary.childrenCount">
                  <b-progress-bar :value="overrideSummary.childrenCompleteCount" class="prog_bar__completed"></b-progress-bar>
                </b-progress>
                </div>
              </div>
              <div class="row txt_row mt-3" v-if="overrideSummary && overrideSummary.overriddenTime">
                <div class="col-12 ">
                  Edited By {{overrideSummary.overriddenBy}} at  {{millisToDate(overrideSummary.overriddenTime)}}
                </div>
              </div>

            <div class="row mt-4">
              <div class="col-12 btn_container" style="text-align: right;">
                <b-button @click="closeLearnerCourseOverrideModal">
                  {{ $tf('ok') }}
                </b-button>
              </div>
            </div>
          </b-modal>
        </div>
<!-- Override Modal -->

  </div>
</template>

<script>
import '../../../assets/module/sass/reports/classReport.scss'
/* eslint no-labels: ["error", { "allowLoop": true }] */
import { DateTime } from 'luxon'
import { mapState, mapActions } from 'vuex'
import { PACKAGE } from '../../../package_constants'
import CourseNav from './CourseNav'
import CourseHeader from './CourseHeader'
import ActivityBarGraph from './ActivityBarGraph'
import ScoreTimeProgress from './ScoreTimeProgress'
import CompetencySummaryProgressBar from './CompetencySummaryProgressBar'
import ClassActivityOutcome from '../../assessment/components/ClassActivityOutcome'
import ManualGrading from '../../assessment/components/ManualGrading'
import _ from 'lodash'

export default {
  name: 'classReport',
  props: ['uuid', 'competencyId', 'isShowLearnosityReport', 'isShowAttemptSummary', 'title', 'users', 'isAdvisorViewingReport'],
  components: {
    CourseNav,
    CourseHeader,
    ActivityBarGraph,
    ScoreTimeProgress,
    CompetencySummaryProgressBar,
    ClassActivityOutcome,
    ManualGrading
  },

  data: () => {
    return {
      items: [],
      breadcrumbItems: [],
      selectedColumns: ['score'],
      columns: [{title: 'Name', summary: '', isClickable: false}],
      fields: [],
      diagnosticTestReport : {},
      isShowDiagnosticTestReport : false,
      userId: '',
      sessionId: '',
      activityId: '',
      attempts: [],
      reGradeItem: '',
      isCourseReport: false,
      showAttemptReport: false,
      showAttemptDeleteBox: false,
      showAttemptScoreBox:false,
      manualGradingParameter: {},
      activityOutcomeParameter: {},
      showManualGradingView: false,
      knowledgeCheckReportTitle: '',
      loadScoreTimeProgressGear: false,
      months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      questions: [],
      attemptSummaries: [],
      questionCols: [],
      isRecalutingClassAverage: false,
      selected: [],
      deleteAttemptRowItem: '',
      deleteAttemptSession: '',
      newScore : undefined,
      overrideSummary: null
    }
  },

  watch: {
    competencyId (value) {
      sessionStorage.clear()
      if (this.uuid === this.competencyId) {
        this.breadcrumbItems = []
        this.loadSummaryForClass(false)
      } else {
        this.loadChildrenSummaryForClass(false)
      }
    },

    isShowAttemptSummary (value) {
      if (value) {
        this.title = undefined
      }
    },

    '$route' (to, from) {
      if (to.query._) {
        this.loadChildrenSummaryForClass(false)
      }
    }
  },

  mounted () {
    this.loadPermission().then(res => {
      this.loadCourse()
    })
  },

  updated () {
    this.setBreadcrumbWidth()
  },

  methods: {
    ...mapActions([
      'loadCourseDetailFromServer',
      'loadFullClassSummary',
      'loadCompetencySummaryForClass',
      'loadChildrenCompetencySummaryForClass',
      'loadAssessmentAttemptForClass',
      'loadFieldsForClassReport',
      'loadFieldsForQuestionLevelClassReport',
      'loadAttemptSummary',
      'loadPermission',
      'loadUnlockQuest',
      'deleteAttempt',
      'updateAttemptScore',
      'exportClassSummaryToCsv',
      'exportLTIAssignmentGrade',
      'loadDiagnosticTestReportForIns',
      'fixMissingSummaries',
      'loadAddOrDropStudentFromClassAverage',
      'loadCourseStatusUpdateForUser',
      'loadCourseStatusUpdateForUsers'
    ]),
    isStatusDisabled (item) {
      let summary = (item.cols) ? item.cols[0].summary : null
      if (summary) {
        return (summary.status === 0)
      }
      return (item.status === 0)
    },
    saveUsersStatusInCourse () {
      this.showLoader()
      let userIdStatusMap = {}
      this.selected.forEach(item => {
        userIdStatusMap[item.userId] = Number(item.status)
      })
      let courseId = this.uuid
      this.loadCourseStatusUpdateForUsers({courseId: courseId, data: userIdStatusMap}).then(resp => {
        if (resp.success === "true") {
          this.notifySuccess(resp.message)
        } else {
          this.notifyFailure(resp.message)
        }
        this.hideLoader()
      })
      this.selected = []
    },
    saveUserStatusInCourse (item) {
      this.showLoader()
      let courseId = this.uuid, userId = item.userId, status = Number(item.status)
      this.loadCourseStatusUpdateForUser({courseId: courseId, userId: userId, status: status}).then(resp => {
        if (resp.success === "true") {
          this.notifySuccess(resp.message)
        } else {
          this.notifyFailure(resp.message)
        }
        this.hideLoader()
      })
    },
    openOverrideDetailModal (summary) {
      this.overrideSummary = summary
      this.$refs.learnerCourseOverrideModal.show()
    },
    closeLearnerCourseOverrideModal () {
      this.$refs.learnerCourseOverrideModal.hide()
    },
    millisToDate (millis) {
      return DateTime.fromMillis(millis).toFormat('MM/dd/yyyy')
    },
    notifySuccess (text) {
      this.$notify({
        group: 'notify',
        type: 'success',
        title: '',
        text: text,
        duration: 5000
      })
    },
    notifyFailure (text) {
      this.$notify({
        group: 'notify',
        type: 'error',
        title: '',
        text: text,
        duration: 5000
      })
    },
    notifyWarning (text) {
      this.$notify({
        group: 'notify',
        type: 'warn',
        title: '',
        text: text
      })
    },
    writeFile (data, fileName1) {
      const blob = new Blob([data], {type: 'text/plain'})
      const e = document.createEvent('MouseEvents')
      let a = document.createElement('a')
      a.download = fileName1?fileName1:this.csvFileName
      a.href = window.URL.createObjectURL(blob)
      a.dataset.downloadurl = ['text/json', a.download, a.href].join(':')
      e.initEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
      a.dispatchEvent(e)
    },
    fixReports(){
      this.fixMissingSummaries(this.uuid)
      this.notifySuccess('Stream Successfully Exported to Csv')
    },
    exportClassSummary () {
      this.showLoader()
      this.exportClassSummaryToCsv({courseId: this.uuid, competencyId: this.competencyId}).then(response => {
        let summaryCsvFile = response && response.fileContents ? response.fileContents : response
        let errors = response && response.error ? response.error : ''
        let warnings = response && response.warning ? response.warning : ''
        if (!summaryCsvFile || !summaryCsvFile.length || summaryCsvFile.length === 0) {
          this.hideLoader()
          return this.notifyFailure(errors)
        }
        this.writeFile(summaryCsvFile)
        if (warnings && warnings.length > 0) {
          this.hideLoader()
          this.notifyWarning(warnings)
        } else {
          this.hideLoader()
          this.notifySuccess('Stream Successfully Exported to Csv')
        }
      })
    },
    async downloadExportLTIAssignmentGrade (){
      this.showLoader()
      let response = await this.exportLTIAssignmentGrade(this.uuid)
      let summaryCsvFile = response && response.fileContents ? response.fileContents : response
      let errors = response && response.error ? response.error : ''
      let warnings = response && response.warning ? response.warning : ''
      if (!summaryCsvFile || !summaryCsvFile.length || summaryCsvFile.length === 0) {
        return this.notifyFailure(errors)
      }
      this.writeFile(summaryCsvFile, this.course.title+'_LTI_Assignment_Grades.csv')
      this.hideLoader()
      if (warnings && warnings.length > 0) {
        this.notifyWarning(warnings)
      } else {
        this.notifySuccess('Course LTI Assignment Grades Successfully Exported.')
      }
    },
    setBreadcrumbWidth () {
      if ((this.breadcrumbItems.length) === 1) {
        $('.breadcrumb').addClass('first-level')
        $('.breadcrumb').removeClass('second-level third-level fourth-level fifth-level')
      } else if ((this.breadcrumbItems.length) === 2) {
        $('.breadcrumb').addClass('second-level')
        $('.breadcrumb').removeClass('first-level third-level fourth-level fifth-level')
      } else if ((this.breadcrumbItems.length) === 3) {
        $('.breadcrumb').addClass('third-level')
        $('.breadcrumb').removeClass('second-level first-level fourth-level fifth-level')
      } else if ((this.breadcrumbItems.length) === 4) {
        $('.breadcrumb').addClass('fourth-level')
        $('.breadcrumb').removeClass('second-level first-level third-level fifth-level')
      } else if ((this.breadcrumbItems.length) === 5) {
        $('.breadcrumb').addClass('fifth-level')
        $('.breadcrumb').removeClass('second-level first-level third-level fourth-level')
      }
    },

    gradeStatus (entity, performance) {
      setTimeout(() => {
        if (performance >= 90) {
          $('#' + entity).addClass('gradeA')
        } else if (performance >= 80 && performance < 90) {
          $('#' + entity).addClass('gradeB')
        } else if (performance >= 65 && performance < 80) {
          $('#' + entity).addClass('gradeC')
        } else if (performance >= 40 && performance < 65) {
          $('#' + entity).addClass('gradeD')
        } else if (performance < 40) {
          $('#' + entity).addClass('gradeE')
        }
      }, 100)
    },

    calculateAndShowTimeTaken (timeTaken) {
      return this.msToTime(timeTaken)
    },

    msToTime (timeTaken) {
      if (timeTaken < 1) {
        return 'N/A'
      }

      var ms = timeTaken % 1000
      timeTaken = (timeTaken - ms) / 1000
      var secs = timeTaken % 60
      timeTaken = (timeTaken - secs) / 60
      var mins = timeTaken % 60
      var hrs = (timeTaken - mins) / 60
      if (hrs < 10) {
        hrs = '0' + hrs
      }
      if (mins < 10) {
        mins = '0' + mins
      }
      if (secs < 10) {
        secs = '0' + secs
      }
      return hrs + ':' + mins + ':' + secs
    },

    getFormattedDateTime (timeInMillis, showOnlyDate) {
      if (timeInMillis === 0) {
        return 'N/A'
      }
      var d
      var str = ''
      d = new Date(timeInMillis)
      str += String(this.months[d.getMonth()])
      str += ' ' + d.getDate()
      str += ', ' + d.getFullYear()
      if (!showOnlyDate) {
        var amPm = ''
        var currHour = d.getHours()
        if (currHour < 12) {
          amPm = 'AM'
        } else {
          amPm = 'PM'
        }
        if (currHour === 0) {
          currHour = 12
        }
        if (currHour > 12) {
          currHour = currHour - 12
        }
        var currMin = d.getMinutes()
        currMin = currMin + ''
        if (currMin.length === 1) {
          currMin = '0' + currMin
        }
        var currSec = d.getSeconds()
        currSec = currSec + ''
        if (currSec.length === 1) {
          currSec = '0' + currSec
        }
        str += ' ' + currHour
        str += ':' + currMin
        str += ':' + currSec
        str += ' ' + amPm
      }
      return str
    },

    loadCourse () {
      this.breadcrumbItems = []
      this.renderClassSummaryData(this.uuid, false)
    },

    loadSummaryForClass (isRecalculatingClassAverage) {
      this.isCourseReport = true
      this.showManualGradingView = false
      this.loadCompetencySummaryForClass(this.uuid).then(res => {
        const response = _.groupBy(res, 'userId')
        this.generateColumnsAndRows(response, true, isRecalculatingClassAverage)
      })
    },

    loadChildrenSummaryForClass (isRecalculatingClassAverage) {
      this.isCourseReport = false
      if (this.isShowLearnosityReport) {
        this.attempts = []
        var to = {name: 'classReport', params: {uuid: this.uuid, competencyId: this.competencyId, isShowLearnosityReport: true, isShowAttemptSummary: false, isAdvisorViewingReport: this.isAdvisorViewingReport}}
        this.updateBreadcrumb(to)
        sessionStorage.setItem('classReportUsers', JSON.stringify(this.users))
        sessionStorage.setItem('classReportLearnosityReport', this.isShowLearnosityReport)
        sessionStorage.setItem('classReportBreadcrumbItems', JSON.stringify(this.breadcrumbItems))
        this.loadFieldsForClassReport({assessmentId: this.competencyId}).then(res => {
          this.fields = res
        })
        this.loadAssessmentAttemptForClass({assessmentId: this.competencyId, users: this.users}).then(res => {
          if (res) {
            for (var i = 0; i < res.length; i++) {
              const attempt = res[i]
              this.attempts.push(attempt)
            }
          }
          this.attempts = _.orderBy(this.attempts, ['name'], ['asc'])
        })
      } else {
        this.loadChildrenCompetencySummaryForClass({courseId: this.uuid, competencyId: this.competencyId}).then(res => {
          const response = _.groupBy(res, 'userId')
          this.generateColumnsAndRows(response, false, isRecalculatingClassAverage)
        })
      }
    },

    generateColumnsAndRows (object, isCourseView, isRecalculatingClassAverage) {
      this.items = []
      this.users = []
      let index = 0
      let entityIds = []
      let resources = []
      $('.sorting_asc').show()
      $('.sorting_desc').hide()
      this.columns = [{title: 'Name', summary: '', isClickable: false}]
      // delete un-enrolled students from response
      if (this.course.unenrolledStudents && this.course.unenrolledStudents.length > 0) {
        this.course.unenrolledStudents.forEach((userId) => {
          delete object[userId]
        })
      }
      for (var key in object) {
        if (object.hasOwnProperty(key)) {
          var user = {}
          var item = {name: '', userId: '', isStudentDropped: false, cols: [], status: 0}
          var values = object[key]
          $.each(values, (i, summary) => {
            if (i === 0) {
              item.status = summary.status
              user[key] = item.name = summary.lastName + ', ' + summary.firstName
              if (!isRecalculatingClassAverage && index === 0) {
                var to = {name: 'classReport', params: {uuid: this.uuid, competencyId: summary.competencyId, isShowLearnosityReport: false, isShowAttemptSummary: false, isAdvisorViewingReport: this.isAdvisorViewingReport}}
                if (isCourseView) {
                  this.breadcrumbItems.push({text: summary.titleForStudent, to: to, active: true})
                } else {
                  this.updateBreadcrumb(to)
                }
              }
            }
            if ($.inArray(summary.entityId, entityIds) === -1) {
              entityIds.push(summary.entityId)
              const title = summary.titleForStudent
              const isClickable = (!isCourseView) ? (i > 0 && (summary.competencyType !== 'RESOURCE')) : true
              const data = {title: title, summary: summary, isClickable: isClickable}
              if (summary.competencyType !== 'RESOURCE') {
                this.columns.push(data)
              } else {
                resources.push(data)
              }
            }
            item.userId = summary.userId
            item.isStudentDropped = _.includes(this.course.droppedStudents, summary.userId)
            const score = (summary.performance !== undefined && summary.performance !== null) ? summary.performance.toFixed(2) : 'N/A'
            const time = this.calculateAndShowTimeTaken(summary.assessmentTimeTaken)
            const resourceTime = this.calculateAndShowTimeTaken(summary.resourceTimeTaken)
            item.cols.push({score: score, time: time, resourceTime: resourceTime, title: summary.titleForStudent, summary: summary, isClickable: ((!isCourseView) ? (i > 0) : true)})
          })
          this.items.push(item)
          this.users.push(user)
          index++
        }
        if (index === Object.keys(object).length) {
          this.columns = this.columns.concat(resources)
          this.updateRowDataPosition()
        }
      }
      this.items = _.orderBy(this.items, ['name'], ['asc'])
      this.showClassAvgScoreAndTime()
      sessionStorage.setItem('classReportBreadcrumbItems', JSON.stringify(this.breadcrumbItems))

      setTimeout(() => {
        this.showHideColumn()
      }, 250)
    },

    updateRowDataPosition () {
      $.each(this.items, (index, item) => {
        firtsLevel: for (var i = 1; i < this.columns.length; i++) {
          var found = false
          var oldIndex = (i - 1)
          var newIndex = (i - 1)
          const column = this.columns[i]
          secondLevel: for (var j = 0; j < item.cols.length; j++) {
            const row = item.cols[j]
            if (column.summary.entityId === row.summary.entityId) {
              found = true
              oldIndex = j
              break secondLevel
            }
          }
          if (found) {
            if (oldIndex !== newIndex) {
              this.changeItemPosition(item.cols, oldIndex, newIndex, column.summary)
            }
          } else {
            const time = (column.summary.competencyType === 'ASSESSMENT') ? '00:00:00' : 'N/A'
            const resourceTime = (column.summary.competencyType === 'RESOURCE') ? '00:00:00' : 'N/A'
            const data = {score: 'N/A', time: time, resourceTime: resourceTime, title: column.summary.titleForStudent, summary: column.summary, isClickable: (column.summary.competencyType !== 'RESOURCE')}
            item.cols.splice(newIndex, 0, data)
          }
        }
      })
    },

    changeItemPosition (arr, oldIndex, newIndex, summary) {
      if (newIndex >= arr.length) {
        var k = newIndex - arr.length + 1
        while (k--) {
          const time = (summary.competencyType === 'ASSESSMENT') ? '00:00:00' : 'N/A'
          const resourceTime = (summary.competencyType === 'RESOURCE') ? '00:00:00' : 'N/A'
          const data = {score: 'N/A', time: time, resourceTime: resourceTime, title: summary.titleForStudent, summary: summary, isClickable: (summary.competencyType !== 'RESOURCE')}
          arr.push(data)
        }
      }
      arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0])
    },

    updateBreadcrumb (to, isQuestionLevelReport) {
      if (this.title) {
        $.each(this.breadcrumbItems, (i, breadcrumbItem) => {
          breadcrumbItem.active = false
          if (i === (this.breadcrumbItems.length - 1)) {
            if (isQuestionLevelReport) {
              breadcrumbItem.to.params.users = this.users
              breadcrumbItem.to.query = {
                _: new Date().getTime()
              }
            }
          }
        })
        var title = (this.breadcrumbItems.length === 1) ? this.breadcrumbItems[0].text : ''
        if (title !== this.title) {
          this.breadcrumbItems.push({text: this.title, to: to, active: true})
        }
      } else {
        var pos = 0
        for (var j = 0; j < this.breadcrumbItems.length; j++) {
          var breadcrumbItem = this.breadcrumbItems[j]
          if (breadcrumbItem.to.params.competencyId === this.competencyId) {
            pos = (j + 1)
            break
          }
        }
        this.breadcrumbItems.splice(pos, (this.breadcrumbItems.length - pos))
        $.each(this.breadcrumbItems, (i, breadcrumbItem) => {
          if (i === (this.breadcrumbItems.length - 1)) {
            breadcrumbItem.active = true
          }
        })
      }
    },

    sortAUsers () {
      var classAvg = this.items.shift()
      this.items = _.orderBy(this.items, ['name'], ['asc'])
      this.items.unshift(classAvg)

      if (this.attempts.length > 0) {
        this.attempts = _.orderBy(this.attempts, ['name'], ['asc'])
      }

      if (this.attemptSummaries.length > 0) {
        this.attemptSummaries = _.orderBy(this.attemptSummaries, ['name'], ['asc'])
      }

      $('.sorting_asc').show()
      $('.sorting_desc').hide()

      setTimeout(() => {
        this.showHideColumn()
      }, 20)
    },

    sortDUsers () {
      var classAvg = this.items.shift()
      this.items = _.orderBy(this.items, ['name'], ['desc'])
      this.items.unshift(classAvg)

      if (this.attempts.length > 0) {
        this.attempts = _.orderBy(this.attempts, ['name'], ['desc'])
      }

      if (this.attemptSummaries.length > 0) {
        this.attemptSummaries = _.orderBy(this.attemptSummaries, ['name'], ['desc'])
      }

      $('.sorting_asc').hide()
      $('.sorting_desc').show()

      setTimeout(() => {
        this.showHideColumn()
      }, 20)
    },

    scrollTable () {
      var tableRowContainer = $('.table_row_container')
      var tableRowHeader = $('.table_row_header')
      var tableFirstCol = $('.table_first_col')

      tableRowHeader.scrollLeft(tableRowContainer.scrollLeft())
      tableFirstCol.scrollTop(tableRowContainer.scrollTop())
    },

    scrollTableHorizontal () {
      var tableRowContainer = $('.table_row_container')
      var tableRowHeader = $('.table_row_header')

      tableRowContainer.scrollLeft(tableRowHeader.scrollLeft())
    },

    scrollAttemptsTable () {
      var namesTblContainer = $('.names_tbl_container')
      var attemptsTblContainer = $('.attempts_tbl_container')
      var attemptsTblContainerHead = $('.attempts_tbl_container thead')
      attemptsTblContainer.scrollTop(namesTblContainer.scrollTop())
      attemptsTblContainer.scrollLeft(attemptsTblContainerHead.scrollLeft())
    },

    scrollAttemptsUserTable () {
      var attemptsTblContainer = $('.attempts_tbl_container')
      var namesTblContainer = $('.names_tbl_container')
      namesTblContainer.scrollTop(attemptsTblContainer.scrollTop())
    },

    scrollQuestionTableUserCol () {
      var tableRowContainer = $('.question-table-inner')
      var tableFirstCol = $('.student-col')
      tableFirstCol.scrollTop(tableRowContainer.scrollTop())
    },

    scrollQuestionTable () {
      var tableRowContainer = $('.question-table-inner')
      var tableFirstCol = $('.student-col')
      tableRowContainer.scrollTop(tableFirstCol.scrollTop())
    },

    showClassAvgScoreAndTime () {
      var item = {name: 'Class Average', cols: []}
      $.each(this.columns, (i, column) => {
        if (i > 0) {
          for (var j = 0; j < this.fullClassSummary.length; j++) {
            const summary = this.fullClassSummary[j]
            if (column.summary.entityId === summary.entityId) {
              const performanceAvg = summary.classPerformance.performanceAvg
              const score = (performanceAvg !== undefined && performanceAvg != null) ? performanceAvg.toFixed(2) : 'N/A'
              const time = this.calculateAndShowTimeTaken(summary.assessmentAvgTimeTaken)
              const resourceTime = this.calculateAndShowTimeTaken(summary.resourceAvgTimeTaken)
              item.cols[i - 1] = {score: score, time: time, resourceTime: resourceTime, summary: column.summary, isClickable: column.isClickable}
              break
            }
          }
          if (i === (this.columns.length - 1)) {
            this.items.unshift(item)
          }
        }
      })
    },

    addOrDropStudentFromClassAverage (courseId, userId, action) {
      this.isRecalutingClassAverage = true
      this.showLoader()
      this.loadAddOrDropStudentFromClassAverage({courseId: this.course.uuid, userId: userId, action: action}).then(res => {
        setTimeout(() => {
          this.renderClassSummaryData(this.course.uuid, true)
        }, 5000)
      })
    },

    renderClassSummaryData (courseId, isRecalculatingClassAverage) {
      this.loadFullClassSummary({courseId: courseId, loadDataFromServer: true}).then(res => {
        if (res && res.length === 0) {
          $('.report-column').html('Report data is not available for this course')
        }
        this.loadCourseDetailFromServer(courseId).then(response => {
          if (this.uuid === this.competencyId) {
            sessionStorage.clear()
            this.loadSummaryForClass(isRecalculatingClassAverage)
          } else {
            this.users = JSON.parse(sessionStorage.getItem('classReportUsers'))
            this.isShowLearnosityReport = sessionStorage.getItem('classReportLearnosityReport')
            this.breadcrumbItems = JSON.parse(sessionStorage.getItem('classReportBreadcrumbItems'))
            sessionStorage.clear()
            this.loadChildrenSummaryForClass(isRecalculatingClassAverage)
          }
          this.hideLoader()
          this.isRecalutingClassAverage = false
        })
      })
    },

    showLoader () {
      if (this.$refs.loadingModal) {
        this.$refs.loadingModal.show()
      }
    },

    hideLoader () {
      if (this.$refs.loadingModal) {
        this.$refs.loadingModal.hide()
      }
    },

    showHideScoreTimeProgressColumn (values) {
      this.selectedColumns = values
      this.showHideColumn()
    },

    showHideColumn () {
      this.loadScoreTimeProgressGear = true
      if ($.inArray('score', this.selectedColumns) === -1) {
        $('.score-column').hide()
        $('.col_row').removeClass('col_1')
      } else {
        $('.score-column').show()
        $('.col_row').addClass('col_1')
      }

      if ($.inArray('time', this.selectedColumns) === -1) {
        $('.time-column').hide()
        $('.col_row').removeClass('col_2')
      } else {
        $('.time-column').show()
        $('.col_row').addClass('col_2')
      }

      if ($.inArray('progress', this.selectedColumns) === -1) {
        $('.progress-column').hide()
        $('.col_row').removeClass('col_3')
      } else {
        $('.progress-column').show()
        $('.non_kc_col').addClass('col_3')
      }

      if ($.inArray('resourceTime', this.selectedColumns) === -1) {
        $('.resource-time-column').hide()
        $('.col_row').removeClass('col_4')
      } else {
        $('.resource-time-column').show()
        $('.col_row').addClass('col_4')
      }

      if ($.inArray('lastActivity', this.selectedColumns) === -1 || !this.isCourseReport) {
        $('.last-activity-column').hide()
        $('.col_row').removeClass('col_5')
      } else {
        $('.last-activity-column').show()
        $('.col_row').addClass('col_5')
      }
    },

    openAttemptReport (item, attempt, index, button) {
      this.reGradeItem = item
      this.reGradeItem.attempt = attempt
      this.showAttemptReport = true
      this.activityOutcomeParameter['userId'] = item.userId
      this.activityOutcomeParameter['sessionId'] = attempt.sessionId
      this.activityOutcomeParameter['activityId'] = attempt.activityId
      this.activityOutcomeParameter['manuallyGraded'] = attempt.manuallyGraded
      this.knowledgeCheckReportTitle = 'Knowledge Check Activity Report - ' + item.name
      this.$root.$emit('bv::show::modal', 'attemptReportInfo', button)
    },

    closeAttemptReport () {
      this.$root.$emit('bv::hide::modal', 'attemptReportInfo')
    },
    showAttemptDeleteConfirmBox (item, attempt, index, button) {
      this.deleteAttemptRowItem = item
      this.deleteAttemptSession = attempt
      this.showAttemptDeleteBox = true
      this.$root.$emit('bv::show::modal', 'attemptDeleteConfirm')
    },

    async showDiagnosticTestReport (assessmentId, userId) {
        this.$refs.diagnosticTestReportInfo.show()
        this.diagnosticTestReport = await this.loadDiagnosticTestReportForIns({userId:userId, courseId: this.course.uuid, assessmentId: assessmentId })
        this.isShowDiagnosticTestReport = true
      },
     closeDiagnosticTestReport () {
        this.$refs.diagnosticTestReportInfo.hide()
      },
    closeAttemptDeleteConfirmBox () {
      this.showAttemptDeleteBox = false
      this.$root.$emit('bv::hide::modal', 'attemptDeleteConfirm')
    },
    deleteAttemptConfirm (item, attempt) {
      this.deleteAttempt(attempt.sessionId)
      this.notifySuccess('Attempt Sucessfully Deleted.')
      this.closeAttemptDeleteConfirmBox ()
      setTimeout(function() {
        window.location.reload()
      }, 500)
      //this.closeAttemptDeleteConfirmBox()
      //window.location.reload()
      /*
       if(window.confirm('Are you sure, this can not be undo ?')){
          this.deleteAttempt(attempt.sessionId)
          this.notifySuccess('Attempt Sucessfully Deleted.')
          setTimeout(() => {
            window.location.reload()
          }, 500)
       }*/
    },
    showAttemptScoreConfirmBox (item, attempt, index, button) {
      this.deleteAttemptRowItem = item
      this.deleteAttemptSession = attempt
      this.showAttemptScoreBox = true
      this.newScore = undefined
      this.$root.$emit('bv::show::modal', 'attemptScoreConfirm')
    },
    closeAttemptScoreConfirmBox () {
      this.showAttemptScoreBox = false
      this.$root.$emit('bv::hide::modal', 'attemptScoreConfirm')
    },
    scoreAttemptConfirm (item, attempt) {
      if(attempt.totalPoints < +this.newScore){
       this.notifyFailure('The input should be equal of less than '+attempt.totalPoints)
       return
       }
      if(!(Number.isInteger(+this.newScore)) || +this.newScore<0) {
       this.notifyFailure('Invalid input, please input positive interger')
       return
      }

      this.updateAttemptScore({sessionId:attempt.sessionId, newScore:this.newScore})
      this.notifySuccess('Attempt Sucessfully Updated.')
      this.closeAttemptScoreConfirmBox ()
      setTimeout(function() {
        window.location.reload()
      }, 500)
    },

    openManualGrading (item, attempt) {
      this.showManualGradingView = true
      this.manualGradingParameter['name'] = item.name
      this.manualGradingParameter['userId'] = item.userId
      this.manualGradingParameter['sessionId'] = attempt.sessionId
      this.manualGradingParameter['activityId'] = attempt.activityId
      this.manualGradingParameter['manualGradingRubricPdfUri'] = attempt.manualGradingRubricPdfUri
    },

    unlockQuest (userId, courseId, entityId) {
      console.log('entityId:', entityId)
      this.loadUnlockQuest({userId: userId, courseId: courseId, contentId: entityId}).then((res) => {
        this.$notify({
          group: 'notify',
          type: 'success',
          title: '',
          text: 'Quest Successfully Unlocked!'
        })
        this.loadCourse()
      })
    },

    afterSaveScore () {
      this.$router.go({
        path: this.$router.path,
        query: {
          t: new Date().getTime()
        }
      })
    },

    showQuestionLevelReport (key, field) {
      const attemptNumber = field.attemptNumber
      if (attemptNumber) {
        this.questions = []
        this.attemptSummaries = []
        this.title = field.label
        var to = {name: 'classReport', params: {uuid: this.uuid, competencyId: this.competencyId, isShowLearnosityReport: true, isShowAttemptSummary: false, isAdvisorViewingReport: this.isAdvisorViewingReport}}
        this.updateBreadcrumb(to, true)
        sessionStorage.setItem('classReportUsers', JSON.stringify(this.users))
        sessionStorage.setItem('classReportLearnosityReport', this.isShowLearnosityReport)
        sessionStorage.setItem('classReportBreadcrumbItems', JSON.stringify(this.breadcrumbItems))
        this.isShowAttemptSummary = true
        this.loadFieldsForQuestionLevelClassReport(this.competencyId).then(res => {
          this.questions = res
          $.each(res, (i, entry) => {
            if (i > 1) {
              this.questionCols.push(entry.key)
            }
          })
        })
        this.loadAttemptSummary({assessmentId: this.competencyId, attemptNumber: attemptNumber, users: this.users}).then(res => {
          this.attemptSummaries = res
          this.attemptSummaries = _.orderBy(this.attemptSummaries, ['name'], ['asc'])
        })
      }
    }
  },

  computed: {
    ...mapState({
      'course': state => state.course.course,
      'fullClassSummary': state => state.course.fullClassSummary,
      'competencySummaryForClass': state => state.course.competencySummaryForClass,
      'childrenCompetencySummaryForClass': state => state.course.childrenCompetencySummaryForClass,
      'permission': state => state.user.permission,
      'institution': state => state.institution.institution,
      'enabledFeatures': state => state.institution.enabledFeatures
    }),
    isAdmin () {
      let permission = this.permission || JSON.parse(localStorage.getItem('userobj'))
      let userPermission = permission.userPermission
      return userPermission.adminHomeView
    },
    csvFileName () {
      let title = this.title
      if (!title || title.length <= 0) {
        return 'Class_Report.csv'
      }
      return title.split(':')[0] + '_Class_Report.csv'
    },
    showExportButton () {
      // this means the user is viewing one column (i.e. a Course with no expanded MC's)
      if (this.uuid === this.competencyId) {
        return false
      }
      // only show export if the user is not viewing a Knowledge Check/Assessment
      let isViewingAssessment = this.isShowLearnosityReport
      return isViewingAssessment !== true
    },
    isCourseStatusDropDownEnabled () {
      if (this.enabledFeatures && this.enabledFeatures[PACKAGE.FEATURE_IDS.COURSE_STATUS_DROP_DOWN_ON_COURSE_REPORT_FEATURE_ID]) {
        return this.enabledFeatures[PACKAGE.FEATURE_IDS.COURSE_STATUS_DROP_DOWN_ON_COURSE_REPORT_FEATURE_ID].enabled
      }
      return false
    },
    isGradeCSVDownloadAllowed () {
        let allowCopyLTILink = this.enabledFeatures['allowCopyLTILink']
        if (allowCopyLTILink) {
          let flags = allowCopyLTILink.flags
          for (var i = 0; i < flags.length; i++) {
            if (flags[i].title === 'Allow download CSV for LTI Assignment grades for Canvas') {
              return flags[i].enabled
            }
          }
        }
        return false
      },
    isUpdateCourseStatus () {
      return this.isCourseStatusDropDownEnabled && this.isAdmin && this.isCourseReport
    }
  }
}
</script>

<style scoped>


.activity-row {
    padding-top:20px;
}

.report-Page .activity-graph-container {
    border: 1px solid #dbdbdb!important;
    border-radius: 0;
    min-height: 270px;
    font-family: openSans_Regular;
}

.report-Page .label {
    background: #c9e0b2;
    padding: 8px;
    color: #4d4d4d;
    font-size: 19px;
}

.report-Page .graph-area {
    height: 228px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.graph-min-height {
    min-height:251px!important;
}

.report-Page .graph-text {
    text-align: center;
    color: #4d4d4d;
    position: relative;
    top: -42px;
}
.report-Page .dashboard-row {
    min-width:1115px;
    padding-left:15px;
}
.report-Page .left-space {
    padding-left:100px;
}

.report-graph {
    flex: 0 0 30%!important;
    max-width: 30%!important;
}

.competency-details-row {
    padding-left:33px;
    height: auto;
}

.competency-details-row .value, .competency-details-row .title {
    width: 100%;
    float: left;
    padding: 8px 8px;
}

.score-column {
    width: 30%;
    display: none;
    margin-top: 15px;
}

.column.progress-column {
    position: relative !important;
    display: none;
    margin-top: 9px;
    padding-top: 0!important;
    padding-bottom: 0!important;
    padding-left: 10px!important;
}

.time-column {
    width: 30%;
    display: none;
}

.column.time-column, .column.resource-time-column {
   height: 44px;
   padding: 0!important;
   display: flex;
   align-items: center;
   justify-content: center;
   margin-top: 9px;
   background: none;
}

.time-value-box {
    padding:10px 15px;
    background:rgb(143, 143, 143);
    color:#fff;
	width:96px;
	text-align:center;
}

.last-activity-value-box {
    padding: 5px 8px;
    background: #8f8f8f;
    color: #fff;
    position: absolute;
    font-size: 12px;
    top: 9px;
    height: 44px;
    width: 94px;
    margin: auto;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
}

.resource-time-column {
    position:relative;
    display: none;
}

.last-activity-column {
    position:relative;
    display: none;
}

.competency_progress {
    width:100%;
    position:static;
}

.table thead {
    background: #f5f5f5;
}

.report-column {
	height:calc(100vh - 261px);
	overflow-y: hidden;
	overflow-x: hidden;
}

.breadcrumb-item {
	max-width: 195px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
@media (max-width: 1024px) {
	.report-column {
		overflow-y:auto;
	}
}

button.attempt-report-close {
    border: 0;
    background: transparent;
    padding: 15px;
    margin: -15px -15px -15px auto;
    cursor: pointer;
    -webkit-appearance: none;
}

.attempt-report-close {
    float: right;
    line-height: 1;
    color: #000;
    text-shadow: 0 1px 0 #fff;
    opacity: .5;
}

.eye {
    width: 28px;
    float: right;
    font-size: 20px;
    margin-top: -23px;
}

</style>



// WEBPACK FOOTER //
// src/app/course/components/ClassReport.vue